// extracted by mini-css-extract-plugin
export default {"container":"VisitsBox_container__grZwI"};